import {EmptyTextWarningControl} from '../../controls/empty-text-warning-control/empty-text-warning-control';
import {LinkWrapperControl} from '../../controls/link-wrapper-control/link-wrapper-control';
import {makeColorControl} from '../../controls/color-control/color-control';
import {linkColorDescriptor, textColorDescriptor} from '../../controls/color-control/color-control-descriptors';
import {makeFontSelectorControl} from '../../controls/font-selector-control/font-selector-control';
import {makeOptionListControl} from '../../controls/option-list-control/option-list-control';
import {fontStyleDescriptor, horizontalAlignDescriptor, textAlignDescriptor} from '../../controls/option-list-control/option-list-control-descriptors';
import {makeSliderControl} from '../../controls/slider-control/slider-control';
import {
  fontSizeDescriptor,
  letterSpacingDescriptor,
  lineHeightDescriptor,
  opacityDescriptor,
  paddingDescriptor,
  widthDescriptor,
} from '../../controls/slider-control/slider-control-descriptors';
import {isOutsideOutlookFontSizeRange} from '@EmailMakerReact/lib/email-maker-compatibility-library';
import {makeStyleHeader} from '../../controls/style-header/style-header';
import {makeCtaButtonControl} from '../../controls/cta-button-control/cta-button-control';
import {copyPasteStylesDescriptor} from '../../controls/cta-button-control/cta-button-control-descriptors';
import {makeAiRewriteControl} from '../../controls/ai-content-control/ai-content-control';
import {MergeTagsControl} from '../../controls/merge-tags-control/merge-tags-control';
import {isTextComponent, registerEmailMakerSector} from '../../right-panel-registry';
import {TileComplexity} from '@EmailMakerReact/lib/email-maker-tile-meta-library.types';
import {deleteControl, duplicateControl, lockControl} from '../shared/common-action-controls';
import {bgColorControl} from '../shared/color-controls';
import {isAiTextEnabled} from '../shared/sector-predicates';
import type {EmailMakerControl} from '../../right-panel-registry.types';

const emptyTextWarningControl: EmailMakerControl = EmptyTextWarningControl;
const stylesHeader: EmailMakerControl = makeStyleHeader('pmwjs_styles');
const urlControl: EmailMakerControl = LinkWrapperControl;
const mergeTagsControl: EmailMakerControl = MergeTagsControl;
const copyPasteStylesControl = makeCtaButtonControl(copyPasteStylesDescriptor);
const aiRewriteControl: EmailMakerControl = makeAiRewriteControl();
const textColorControl = makeColorControl(textColorDescriptor);
const linkColorControl = makeColorControl(linkColorDescriptor);
const fontControl = makeFontSelectorControl();
const fontStyleControl = makeOptionListControl(fontStyleDescriptor);
const textAlignControl = makeOptionListControl(textAlignDescriptor);
const horizontalAlignControl = makeOptionListControl(horizontalAlignDescriptor);
const textFontSizeControl = makeSliderControl({
  ...fontSizeDescriptor,
  warning: {contentKey: 'pmwjs_outlook_font_size_warning', isVisible: isOutsideOutlookFontSizeRange},
});
const lineHeightControl = makeSliderControl(lineHeightDescriptor);
const letterSpacingControl = makeSliderControl(letterSpacingDescriptor);
const opacityControl = makeSliderControl(opacityDescriptor);
const widthControl = makeSliderControl(widthDescriptor);
const paddingControl = makeSliderControl(paddingDescriptor);

registerEmailMakerSector((component) => isTextComponent(component), {
  title: window.i18next.t('pmwjs_text'),
  properties: [
    {control: emptyTextWarningControl},
    {control: duplicateControl},
    {control: lockControl},
    {control: deleteControl},
    {control: aiRewriteControl, isVisible: isAiTextEnabled, actionMeta: {icon: 'icon-ai-caption', labelKey: 'pmwjs_ai_rewrite', complexity: TileComplexity.COMPLEX}},
    {control: urlControl, actionMeta: {icon: 'icon-link', labelKey: 'pmwjs_link', complexity: TileComplexity.SIMPLE}},
    {control: mergeTagsControl, actionMeta: {icon: 'icon-tags', labelKey: 'pmwjs_merge_tags', complexity: TileComplexity.COMPLEX}},
    {control: stylesHeader},
    {control: copyPasteStylesControl},
    {control: bgColorControl, tileMeta: {icon: 'icon-fill', labelKey: 'pmwjs_background_color', complexity: TileComplexity.SIMPLE}},
    {control: textColorControl, tileMeta: {icon: 'icon-text-fill', labelKey: 'pmwjs_text_color', complexity: TileComplexity.SIMPLE}},
    {control: linkColorControl, tileMeta: {icon: 'icon-link', labelKey: 'pmwjs_link_color', complexity: TileComplexity.SIMPLE}},
    {control: fontControl, tileMeta: {icon: 'icon-font', labelKey: 'pmwjs_font', complexity: TileComplexity.SIMPLE}},
    {control: textFontSizeControl, tileMeta: {icon: 'icon-text-size', labelKey: 'pmwjs_font_size', complexity: TileComplexity.SIMPLE}},
    {control: fontStyleControl, tileMeta: {icon: 'icon-bold', labelKey: 'pmwjs_style', complexity: TileComplexity.SIMPLE}},
    {control: textAlignControl, tileMeta: {icon: 'icon-align-center', labelKey: 'pmwjs_alignment', complexity: TileComplexity.SIMPLE}},
    {control: horizontalAlignControl, tileMeta: {icon: 'icon-h-align-center', labelKey: 'pmwjs_horizontal_alignment', complexity: TileComplexity.SIMPLE}},
    {control: lineHeightControl, tileMeta: {icon: 'icon-line-height', labelKey: 'pmwjs_line_height', complexity: TileComplexity.SIMPLE}},
    {control: letterSpacingControl, tileMeta: {icon: 'icon-letter-spacing', labelKey: 'pmwjs_letter_spacing', complexity: TileComplexity.SIMPLE}},
    {control: opacityControl, tileMeta: {icon: 'icon-opacity', labelKey: 'pmwjs_opacity', complexity: TileComplexity.SIMPLE}},
    {control: widthControl, tileMeta: {icon: 'icon-stretch-horizontal', labelKey: 'pmwjs_width', complexity: TileComplexity.SIMPLE}},
    {control: paddingControl, tileMeta: {icon: 'icon-edge-spacing', labelKey: 'pmwjs_spacing', complexity: TileComplexity.COMPLEX}},
  ],
});
